<template>
	<v-toolbar
		app
		height="40"
		class="media-print main-header-page align-center"
		:class="{ 'toggle': isVisible }">
		<!-- <button
			class="btn-toggle d-flex"
			@click="$emit('open')"
		>
			<img src="/static/img/toggle.svg" alt="" height="14" width="19">
		</button> -->
		<div class="title-header"></div>
		<div class="d-flex tw-mr-4"
			:style="`color:${$appColors.info}`"
			v-for="(route, indexRoute) in breadCrumbs"
			:key="indexRoute">
			<!-- <img v-if="logoUrl" :src="logoUrl" alt="title" class="icon-header"> -->
			<h1

				v-if="route.name === $route.name || indexRoute === 0"
				class="header-page-title"
				><router-link
					v-if='route.meta.title'
					class="header-page-title"
					:to="{ name: route.name }"
					:style="`color:${$appColors.primary};text-decoration:none`"
				>
				{{ route.meta.title}}
				</router-link>
			</h1>
			<template v-else>
				<router-link
					v-if='route.meta.title'
					class="header-page-title"
					:to="{ name: route.name }"
					:style="`color:${$appColors.primary};text-decoration:none`"
				></router-link>
				<!--{{  'Resultados' }}</router-link-->

				<!-- <div class="mx-2" v-if="breadCrumbs.length !== indexRoute + 1"></div> -->
			</template>

		</div>
		<v-tooltip left>
			<v-btn
				slot="activator"
				class="logout-btn"
				icon
				@click="logout"
			>
				<img src="/static/img/login/logout.svg" alt="Log out">
			</v-btn>
			<span>Cerrar Sesión</span>
		</v-tooltip>
	</v-toolbar>
</template>

<script>
import { mapState } from 'vuex';
import helper from '@/shared/helper';

const { getLocalData, setLocalData } = helper;

function created() {
	this.loadTools();
	this.getBreadCrumbs();
}

async function loadTools() {
	const { data: response } = await this.$http.get('tools');
	this.tools = response;
	setLocalData('tools', this.tools);
}

async function logout() {
	try {
		await this.$httpAcl.post('logout');
		await this.$store.dispatch('jobEvaluation/cleanJobEvaluationState');
		window.localStorage.clear();
		this.showNotification('Se ha cerrado la sesión');
		this.goTo('login');
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function getBreadCrumbs() {
	const { matched } = this.$route;
	const [, ...rest] = matched;
	this.breadCrumbs = rest.filter(r => !this.sideBarRoutes[r.name]);
}

function routeHandler() {
	this.getBreadCrumbs();
}

function routeParams({ toolId }) {
	const toolIdValue = Number(this.toolId) || Number(toolId);
	const routeTool = this.tools.find(t => t.id === toolIdValue);
	this.secondRoute = routeTool ? routeTool.name : '';
	setLocalData('toolSelected', this.secondRoute);
}

function mounted() {
	this.secondRoute = getLocalData('toolSelected');
}

function data() {
	return {
		breadCrumbs: [],
		secondRoute: '',
		tools: [],
	};
}

export default {
	name: 'app-header',
	computed: {
		...mapState({
			sideBarRoutes: state => state.sideBarRoutes,
		}),
	},
	created,
	data,
	methods: {
		getBreadCrumbs,
		loadTools,
		logout,
		routeHandler,
	},
	mounted,
	props: {
		isVisible: {
			type: Boolean,
			default: false,
		},
		logoUrl: String,
		title: String,
		toolId: [Number, String],
	},
	watch: {
		'$route.fullPath': routeHandler,
		'$route.params': routeParams,
	},
};
</script>

<style lang="scss" scoped>

	.main-header-page {
		.header-page-title {
			font-family: font(bold);
			font-size: size(xlarge);

			&-second {
				font-family: font(light);
				font-size: size(large);
			}
		}

		.btn-toggle {
			background: none !important;
			box-shadow: none;
			height: 18px;
			margin-left: 18px;
			margin-right: 30px;
		}

		.wrapper-btn-toggle {
			align-items: center;
			display: flex;
			justify-content: flex-end;
			padding-right: 30px;
		}
		.title-header {
			padding-left: 40px;
		}
	}

	.media-print {
		background: color(white);
		box-shadow: none;
		display: flex;
		height: 72px;
		padding-left: 70px !important;
		@media (max-width: 950px) {
			display: center;
		}
		&.toggle {
			padding-left: 200px !important;
			@media (max-width: 950px) {
			padding-left: 0px !important;
			}
		}
	}

	.icon-header {
		filter: brightness(0) invert(0.3);
		// height: 2rem;
		height: 19px;
		padding-right: 9px;
	}

	.logout-btn {
		bottom: 0px;
		margin: auto;
		position: absolute;
		right: 41px;
		top: 0px;
	}

	.breadcrumb-wrap {
		align-items: center;
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-header.vue